import React, {useEffect, useRef, useState} from 'react';
import {useLocation} from "react-router-dom";
import styles from './SessionMonitorComponent.module.css'
import {checkAuthStatus} from "../../utils/HealthCheckHelper";

const REFRESH_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes

const SessionMonitorComponent: React.FC = () => {
    const [loggedOut, setLoggedOut] = useState<boolean | null>(null);
    const isInitialCheckDone = useRef(false);
    const location = useLocation();

    useEffect(() => {
        const checkSession = async () => {
            if (globalThis.location.pathname === '/login' ||
                globalThis.location.pathname.startsWith('/reset-password')) {
                setLoggedOut(false);
                isInitialCheckDone.current = true;
                return;
            }

            try {
                const userInfo = await checkAuthStatus();
                setLoggedOut(!userInfo);
            } catch (error) {
                console.error('Session check failed:', error);
                setLoggedOut(true);
            } finally {
                isInitialCheckDone.current = true;
            }
        };

        checkSession();
        const intervalId = globalThis.setInterval(checkSession, REFRESH_INTERVAL_MS);
        return () => clearInterval(intervalId);
    }, [location.pathname]);

    if (!isInitialCheckDone.current || loggedOut !== true) return null;

    return (
        <div className={styles.dialog}>
            <div className={styles.box}>
                <h2>Logged out</h2>
                <p>You have been logged out</p>
                <button onClick={() => globalThis.location.reload()}>OK</button>
            </div>
        </div>
    );
};

export default SessionMonitorComponent;